import "select2";
import "bootstrap-daterangepicker";

export function initServiceOrderFilters() {
    // Toggle Filter Drawer
    $("#btnFilter").on("click", function () {
        $("#filtersDrawer").addClass("open");
        $("#filtersDrawerBackdrop").addClass("show");
        $("body").addClass("overflow-hidden");
    });

    $(".btn-close-filters, #filtersDrawerBackdrop").on("click", function () {
        $("#filtersDrawer").removeClass("open");
        $("#filtersDrawerBackdrop").removeClass("show");
        $("body").removeClass("overflow-hidden");
    });

    // Initialize Date Range Pickers
    const datePickerConfig = {
        autoUpdateInput: false,
        locale: {
            cancelLabel: "Limpar",
            applyLabel: "Aplicar",
            format: "DD/MM/YYYY",
            daysOfWeek: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"],
            monthNames: [
                "Janeiro",
                "Fevereiro",
                "Março",
                "Abril",
                "Maio",
                "Junho",
                "Julho",
                "Agosto",
                "Setembro",
                "Outubro",
                "Novembro",
                "Dezembro",
            ],
        },
    };

    // Emissão
    $("#emissaoRange").daterangepicker(datePickerConfig);
    $("#emissaoRange").on("apply.daterangepicker", function (ev, picker) {
        $(this).val(
            picker.startDate.format("DD/MM/YYYY") +
                " - " +
                picker.endDate.format("DD/MM/YYYY")
        );
        $("#emissaoDe").val(picker.startDate.format("YYYY-MM-DD"));
        $("#emissaoAte").val(picker.endDate.format("YYYY-MM-DD"));
    });
    $("#emissaoRange").on("cancel.daterangepicker", function (ev, picker) {
        $(this).val("");
        $("#emissaoDe").val("");
        $("#emissaoAte").val("");
    });

    // Conclusão
    $("#conclusaoRange").daterangepicker(datePickerConfig);
    $("#conclusaoRange").on("apply.daterangepicker", function (ev, picker) {
        $(this).val(
            picker.startDate.format("DD/MM/YYYY") +
                " - " +
                picker.endDate.format("DD/MM/YYYY")
        );
        $("#conclusaoDe").val(picker.startDate.format("YYYY-MM-DD"));
        $("#conclusaoAte").val(picker.endDate.format("YYYY-MM-DD"));
    });
    $("#conclusaoRange").on("cancel.daterangepicker", function (ev, picker) {
        $(this).val("");
        $("#conclusaoDe").val("");
        $("#conclusaoAte").val("");
    });

    // Initialize Select2 for Clients
    $("#clienteSelect").select2({
        placeholder: "Selecione o cliente",
        language: "pt-BR",
        allowClear: true,
        width: "100%",
        ajax: {
            url: "/clientes/getClients",
            type: "POST",
            dataType: "json",
            delay: 250,
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
            },
            data: function (params) {
                return {
                    value: params.term, // Controller expects 'value'
                };
            },
            processResults: function (data) {
                // Adjust based on actual response structure from ClientsController
                const results = Array.isArray(data) ? data : data.results || [];
                return {
                    results: results.map(function (item) {
                        return {
                            id: item.id,
                            text: item.nome || item.razao_social,
                        };
                    }),
                };
            },
            cache: true,
        },
    });

    // Initialize Select2 for Vehicles
    $("#veiculoSelect").select2({
        placeholder: "Selecione o veículo",
        allowClear: true,
        width: "100%",
        ajax: {
            url: "/veiculos/getVehicles",
            type: "POST",
            dataType: "json",
            delay: 250,
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
            },
            data: function (params) {
                return {
                    value: params.term,
                };
            },
            processResults: function (data) {
                const results = Array.isArray(data) ? data : data.results || [];
                return {
                    results: results.map(function (item) {
                        return {
                            id: item.id,
                            text:
                                item.placa +
                                " - " +
                                (item.brand?.nomeMarca || "") +
                                " " +
                                (item.model?.nomeModelo || ""),
                        };
                    }),
                };
            },
            cache: true,
        },
    });

    // Initialize Select2 for Responsavel (Employees)
    // Assuming we can use searchEmployee or fetch all employees.
    // If no dedicated dropdown route, we might need one.
    // For now, let's try to load them if possible or leave it as a static select if populate server-side.
    // But the blade shows an empty select.
    // Let's use searchEmployee if available or leave it for now if complex.
    // Actually, let's use a simple AJAX call to populate it on load or use select2 ajax.
    $("#responsavelSelect").select2({
        placeholder: "Selecione o responsável",
        allowClear: true,
        width: "100%",
        ajax: {
            url: "/funcionarios/getEmployees",
            type: "POST",
            dataType: "json",
            delay: 250,
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
            },
            data: function (params) {
                return {
                    value: params.term || "",
                };
            },
            processResults: function (data) {
                const results = Array.isArray(data) ? data : data.results || [];
                return {
                    results: results.map(function (item) {
                        return {
                            id: item.id,
                            text: item.nome,
                        };
                    }),
                };
            },
            cache: true,
        },
    });
    // NOTE: Responsavel might need a dedicated endpoint returning JSON list of employees.
    // If searchEmployee returns view, this select2 will fail.
    // For now, disabling AJAX for responsavel to prevent errors, assuming it might be populated server-side or needs future work.
    // $("#responsavelSelect").select2("destroy"); // Revert to normal select if not working

    // Apply Filters
    function applyFilters() {
        $(document).trigger("search:refresh");

        const filters = {
            emissao_de: $("#emissaoDe").val(),
            conclusao_de: $("#conclusaoDe").val(),
            status_os: $("#statusOS").val(),
            status_pagamento: $("#statusPagamento").val(),
            responsavel: $("#responsavelSelect").val(),
            cliente: $("#clienteSelect").val(),
            veiculo: $("#veiculoSelect").val(),
        };

        // Count active filters
        let activeCount = 0;
        if (filters.emissao_de) activeCount++;
        if (filters.conclusao_de) activeCount++;
        if (filters.status_os) activeCount++;
        if (filters.status_pagamento) activeCount++;
        if (filters.responsavel) activeCount++;
        if (filters.cliente && filters.cliente.length > 0) activeCount++;
        if (filters.veiculo && filters.veiculo.length > 0) activeCount++;

        if (activeCount > 0) {
            $("#filterCount").text(activeCount).show();
        } else {
            $("#filterCount").hide();
        }

        // Close drawer if open
        if ($("#filtersDrawer").hasClass("open")) {
            $(".btn-close-filters").trigger("click");
        }
    }

    $("#btnApplyFilters").on("click", applyFilters);

    $("#btnClearAllFilters").on("click", function () {
        const form = $("#serviceOrdersFiltersForm");
        if (form.length > 0 && typeof form[0].reset === "function") {
            form[0].reset();
        }
        $("#emissaoDe").val("");
        $("#emissaoAte").val("");
        $("#conclusaoDe").val("");
        $("#conclusaoAte").val("");
        $("#clienteSelect").val(null).trigger("change");
        $("#veiculoSelect").val(null).trigger("change");
        $("#responsavelSelect").val(null).trigger("change");
        $("#statusOS").val("").trigger("change");
        $("#statusPagamento").val("").trigger("change");

        applyFilters();
    });
}
